import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react'
import SimpleReactValidator from 'simple-react-validator';
import service from '../services';
import Dropdown from "./Dropdown";
import DropdownMaster from './DropdownMaster';
import MembershipConfirmPopup from './MembershipConfirmPopup';

let sub
const ManageMembershipModel = (props) => {
    const apiServe = new service()
    const loader = apiServe.loader
    const [paymentOption,] = useState(['Cash', 'Check', 'Invoice', 'Other'])
    const { CloseModal, clickUserMembership } = props
    const [currentMembership, setCurrentMembership] = useState([])
    const [membershipOption, setMembershipOption] = useState({})
    const [isLoader, setIsLoader] = useState(false)
    const [showConfirmPopup, setShowConfirmPopup] = useState(false)
    const [, updateState] = React.useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);
    const Validator = useRef(new SimpleReactValidator({
        autoForceUpdate: this,
        validators: {
            requiredMag: {  // name the rule
                message: 'This field is required.',
                rule: (val, params, validator) => {
                    return validator.helpers.testRegex(val, /^[\s\t\r\n]*\S+/ig) && params.indexOf(val) === -1
                },
                required: true  // optional

            },
        }
    }))
    const [formData, setFormData] = useState({
        membershipId: '',
        userId: clickUserMembership._id,
        paymentMethod: '',
        email: clickUserMembership.email,
        currentMembershipId: clickUserMembership?.membershipDeatils?.membershipId && clickUserMembership.membershipDeatils?.status !== "canceled" ? clickUserMembership?.membershipDeatils?.membershipId : '',
        currentMembershipName: '',
        newMembershipName: '',
        cancelDate: moment().add(12, 'M'),
    })
    const compare = (a, b) => {
        if (a.index < b.index) {
            return -1;
        }
        if (a.index > b.index) {
            return 1;
        }
        return 0;
    }
    const GetCurrentMembership = (newData) => {

        if (clickUserMembership.membershipDeatils?.membershipId !== '' && clickUserMembership.membershipDeatils?.membershipId !== undefined) {
            let current = newData.docs.find(_ => _._id === clickUserMembership.membershipDeatils.membershipId)

            if (current) {
                setCurrentMembership(current)
            }
        }
    }
    const handleInputChange = (e) => {

        const { name, value } = e.target

        if (name === 'membershipId') {
            let data = membershipOption.docs.find(_ => _._id === value)
            setFormData({
                ...formData,
                [name]: value,
                newMembershipName: data.name,
                currentMembershipName: clickUserMembership.membershipDeatils?.status !== "canceled" ? currentMembership.name : 'none'
            })
        } else { setFormData({ ...formData, [name]: value, currentMembershipName: clickUserMembership.membershipDeatils?.status !== "canceled" ? currentMembership.name : 'none' }) }

    }
    useEffect(() => {
        apiServe.sendevent('ticketCms|membership|getMembershipByType', { group: 'all' })
        setIsLoader(true)
        sub = apiServe.getevent().subscribe((response) => {
            switch (response.event) {
                case "ticketCms|membership|getMembershipByType":
                    if (response.error) {
                    } else {

                        let newData = JSON.parse(JSON.stringify(response.data))
                        newData.docs = newData.docs.sort(compare);

                        GetCurrentMembership(newData)

                        setMembershipOption(newData)
                        setIsLoader(false)
                    }
                    break;
                case 'admin|membership|updateMembership':
                    if (!response.error) {
                        apiServe.success('Membership Upgrade Successful.')
                        setShowConfirmPopup(false)
                        CloseModal()
                    } else {
                        
                        apiServe.error(response.data.error)
                        setShowConfirmPopup(false)
                        CloseModal()
                    }
                    break;
                case 'admin|membership|addMembership':
                    if (!response.error) {
                        apiServe.success('Membership Add Successful.')
                        setShowConfirmPopup(false)
                        CloseModal()
                    } else {
                        
                        apiServe.error(response.data.error)
                        setShowConfirmPopup(false)
                        CloseModal()
                    }
                    break;
                default:
                    break;
            }
        });
        return () => {
            sub.unsubscribe()
        }
    }, [])
    const SubmitMembership = () => {
        if (Validator.current.allValid()) {

            setShowConfirmPopup(true)
        } else {
            Validator.current.showMessages();
            forceUpdate();
        }
    }
    const closeConfirmPopup = () => {
        setShowConfirmPopup(false)
    }
    const confirmConfirmPopup = () => {
        if (Object.keys(currentMembership).length !== 0 && clickUserMembership.membershipDeatils?.status !== "canceled" ) {
            let data = {
                userId: formData.userId,
                currentMembershipId: formData.currentMembershipId,
                membershipId: formData.membershipId,
                paymentMethod: formData.paymentMethod,
                cancelDate: formData.cancelDate,
                isOffline:true,
            }
            apiServe.sendevent('admin|membership|updateMembership', data)
        } else {
            let data = {
                userId: formData.userId,
                membershipId: formData.membershipId,
                paymentMethod: formData.paymentMethod,
                cancelDate: formData.cancelDate,
                isOffline:true,
            }
            apiServe.sendevent('admin|membership|addMembership', data)
        }
    }
    const ClearForm = () => {
        setFormData({
            ...formData,
            membershipId: '',
            paymentMethod: ''
        })
    }
    return (
        <>
            <div className="user_popup active">
                <span className="popup_overlay" onClick={CloseModal}></span>
                <div className="editaccount sundance_popup_detail box_shadow">
                    <div className="bg_white">
                        <div className="form_header text_center">
                            <div className="d_flex d_flex_justify_center d_flex_align_center">
                                <h4 className="form_heading">Manage Membership</h4>
                            </div>
                            <span className="closePopup pointer" onClick={CloseModal}>
                                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10.192 0.181396L5.94897 4.55825L1.70697 0.181396L0.292969 1.64035L4.53497 6.0172L0.292969 10.394L1.70697 11.853L5.94897 7.47615L10.192 11.853L11.606 10.394L7.36397 6.0172L11.606 1.64035L10.192 0.181396Z" fill="white" />
                                </svg>
                            </span>
                        </div>

                        <div className="recipt_modal">
                            <div className="membership_popup">
                                <div className="membership_bg">
                                    <div className="user_info_title d_flex d_flex_justify_center d_flex_align_center">
                                        <p>User Information</p>
                                    </div>
                                    <div className="user_details">
                                        <form >
                                            <div className="details d_flex">
                                                <div className="form_group">
                                                    <label>FirstName</label>
                                                    <div className="form_group_input">
                                                        <input type="text" name="FirstName" id="FirstName" tabIndex='2' value={clickUserMembership.fname} onChange={handleInputChange} disabled />
                                                    </div>
                                                </div>
                                                <div className="form_group">
                                                    <label>Last Name</label>
                                                    <div className="form_group_input">
                                                        <input type="text" name="LastName" id="LastName" tabIndex='2' value={clickUserMembership.lname} onChange={handleInputChange} disabled />
                                                    </div>
                                                </div>
                                                <div className="form_group">
                                                    <label>Email</label>
                                                    <div className="form_group_input">
                                                        <input type="email" name="email" id="email" tabIndex='2' maxLength={255} value={clickUserMembership.email} onChange={handleInputChange} disabled />
                                                    </div>
                                                </div>


                                            </div>

                                        </form>
                                    </div>
                                    <div className="user_info_title d_flex d_flex_justify_center d_flex_align_center">
                                        <p>Manage Membership</p>
                                    </div>
                                    <div className="current_membership d_flex d_flex_justify_center d_flex_align_center">
                                        <p>Current Membership: {clickUserMembership.membershipDeatils?.membershipId && clickUserMembership.membershipDeatils?.status !== "canceled" ? currentMembership?.name : 'none'}</p>
                                    </div>
                                    <div className="user_details">
                                        <form className="membership_form">
                                            <div className="details d_flex  d_flex_justify_center">
                                                <div className="form_group">
                                                    <label>New Membership Level</label>
                                                    <div className="form_group_input no_bg">
                                                        <DropdownMaster optionDisableIndex={clickUserMembership.membershipDeatils?.status !== "canceled" ? currentMembership.index : 0} options={membershipOption.docs} name='membershipId' value={formData.membershipId} fpgerror={Validator.current.message('membershipId', formData.membershipId, 'requiredMag')} isOptionDisabled={true} onChange={handleInputChange} />
                                                        {isLoader && <img className='mini_loader' src={loader} />}
                                                    </div>
                                                </div>
                                                <div className="form_group">
                                                    <label>Payment Method</label>
                                                    <div className="form_group_input no_bg">
                                                        <Dropdown options={paymentOption} DefaultOption={'Select from list'} onChange={handleInputChange} name='paymentMethod' value={formData.paymentMethod} fpgerror={Validator.current.message('paymentMethod', formData.paymentMethod, 'requiredMag')} />
                                                    </div>
                                                </div>


                                            </div>

                                        </form>
                                    </div>
                                </div>
                                <div className="btn_wrapper">
                                    <button className="grayBTN" type="button" onClick={() => CloseModal()}>Cancel</button>
                                    <button className="orangeBTN" type="button" onClick={() => SubmitMembership()}>Submit</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/*  */}
            {showConfirmPopup ? <MembershipConfirmPopup ClosePopup={closeConfirmPopup} ConfirmPopup={confirmConfirmPopup} newMembershipDetail={formData} /> : ''}
        </>
    )

}
export default ManageMembershipModel